import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class CardErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console in development
    if (process.env.NODE_ENV !== 'production') {
      console.error('Card Error Boundary caught an error:', error, errorInfo);
    }
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-4 mb-4">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-red-800 dark:text-red-200">
                Card Error
              </h3>
              <p className="text-xs text-red-700 dark:text-red-300 mt-1">
                Something went wrong displaying this card. You can try refreshing or continue with other cards.
              </p>
              {process.env.NODE_ENV !== 'production' && this.state.error && (
                <details className="mt-2 text-xs text-red-600 dark:text-red-400">
                  <summary className="cursor-pointer hover:text-red-800 dark:hover:text-red-200">
                    Error Details (Development)
                  </summary>
                  <pre className="mt-1 p-2 bg-red-100 dark:bg-red-900/30 rounded text-xs overflow-auto">
                    {this.state.error.toString()}
                    {this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
            </div>
            <button
              onClick={this.handleRetry}
              className="flex-shrink-0 p-1.5 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30 rounded-lg transition-colors"
              title="Retry"
            >
              <RefreshCw className="w-4 h-4" />
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default CardErrorBoundary;
